import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/trade_apply_record_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  type_eq: {
    column_type: 'type',
    extra: {
      options: ['AllotTradeApplyRecord', 'RedeemTradeApplyRecord'],
    },
    model_name: 'TradeApplyRecord',
    column_name: 'type',
  },
  account_id_eq: {
    column_type: 'belongs_to',
    column_name: 'account',
    extra: {
      model_name: 'Account',
    },
    model_name: 'TradeApplyRecord',
  },
  account: {
    column_type: 'belongs_to',
    column_name: 'account',
    extra: {
      model_name: 'Account',
    },
    model_name: 'TradeApplyRecord',
  },
  applicant_id_eq: {
    column_type: 'belongs_to',
    column_name: 'applicant',
    extra: {
      model_name: 'Account',
    },
    model_name: 'TradeApplyRecord',
  },
  applicant: {
    column_type: 'belongs_to',
    column_name: 'applicant',
    extra: {
      model_name: 'Account',
    },
    model_name: 'TradeApplyRecord',
  },
  fund_id_eq: {
    column_type: 'belongs_to',
    column_name: 'fund',
    extra: {
      model_name: 'Fund',
    },
    model_name: 'TradeApplyRecord',
  },
  fund: {
    column_type: 'belongs_to',
    column_name: 'fund',
    extra: {
      model_name: 'Fund',
    },
    model_name: 'TradeApplyRecord',
  },
  state_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'TradeApplyRecord',
      options: ['pending', 'approved', 'rejected'],
    },
    model_name: 'TradeApplyRecord',
    column_name: 'state',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('TradeApplyRecord', columns), filterColumnsExtend)
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('TradeApplyRecord', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
